export const gendersEnum = {
    male: 0,
    female: 1,
};